var _g, _circle, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiChatDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9652_43034)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.3635,
    y: 6.36353,
    width: 47.2727,
    height: 47.2727,
    rx: 23.6364,
    fill: "url(#paint0_linear_9652_43034)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 25.5,
    stroke: "#2ABDEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9652_43034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3635 34.7272V33.1515H37.1514V27.6363H36.3635V26.0605H39.515V27.6363H38.7272V33.1515H39.515V34.7272H36.3635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6064 34.7272H35.1822L32.4242 26.0605H30.0606L27.3057 34.7272H28.8805L29.3546 33.1515H33.1192L33.6064 34.7272ZM29.8288 31.5757L31.1117 27.3124L31.3134 27.3105L32.632 31.5758L29.8288 31.5757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6058 20.5453H43.4543V17.3938H41.8786V20.5453H38.7271V22.1211H41.8786V25.2726H43.4543V22.1211H46.6058V20.5453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.606 26.8484H45.0303V28.4241H46.606V26.8484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1514 17.3938H35.5757V18.9696H37.1514V17.3938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6059 42.6059H21.3938V17.3938H32.4241V18.9696H22.9696V41.0302H45.0302V31.5756H46.6059V42.6059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9652_43034",
    x: 0.363525,
    y: 0.363525,
    width: 67.2727,
    height: 67.2727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9652_43034"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0 0.525 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9652_43034"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9652_43034",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9652_43034",
    x1: 33.9999,
    y1: 6.36353,
    x2: 33.9999,
    y2: 53.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9652_43034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2121,
    height: 25.2121,
    fill: "white",
    transform: "translate(21.3938 17.3938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatDisabled);
export default __webpack_public_path__ + "static/media/AIChatDisabled.c2068fb150c6ce7ac45ff6062160694a.svg";
export { ForwardRef as ReactComponent };